import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';

import { Tabs, TabsList, TabsTrigger } from 'twyne-new.ui';

const AppTabsRouter = ({ children }) => {
  const availableTabs = React.Children.toArray(children).map(({ props: { children, to, exact } }) => ({ children, to, exact }))

  return <Tabs>
    <TabsList className='px-8'>
      {availableTabs.map(({ children, to, exact }) => <TabItem key={`key-${exact}`} label={children} to={to} exact={exact} />)}
    </TabsList>
  </Tabs>
}

const TabItem = ({ label, to, exact }) => {
  const match = useRouteMatch({ path: to, exact })
  return <NavLink exact={exact} to={to}>
    <TabsTrigger data-state={match ? 'active' : 'inactive'} value={label.toLowerCase()}>{label}</TabsTrigger>
  </NavLink>
}

const AppTabsRouterItem = () => null

export { AppTabsRouter, AppTabsRouterItem }
